// Block types catalog with default values, icons, and friendly labels
import {
  Plane, Car, Building, Compass, FileText, Map as MapIcon, Image as ImageIcon,
  Video, CalendarDays, Sparkles
} from "lucide-react";

export const BLOCK_TYPES = [
  { type: "intro", label: "Introduction", icon: Sparkles },
  { type: "day_separator", label: "Jour", icon: CalendarDays },
  { type: "flight", label: "Vol", icon: Plane },
  { type: "transfer", label: "Transfert", icon: Car },
  { type: "hotel", label: "Hôtel", icon: Building },
  { type: "activity", label: "Activité", icon: Compass },
  { type: "map", label: "Carte", icon: MapIcon },
  { type: "gallery", label: "Galerie", icon: ImageIcon },
  { type: "video", label: "Vidéo YouTube", icon: Video },
  { type: "note", label: "Note libre", icon: FileText },
];

export const BLOCK_LABEL = Object.fromEntries(BLOCK_TYPES.map((b) => [b.type, b.label]));
export const BLOCK_ICON = Object.fromEntries(BLOCK_TYPES.map((b) => [b.type, b.icon]));

export const newBlock = (type) => ({
  id: Math.random().toString(36).slice(2, 10),
  type,
  title: "",
  subtitle: "",
  description: "",
  date: null,
  time_start: null,
  time_end: null,
  location: null,
  address: null,
  map_query: null,
  images: [],
  video_url: null,
  departure: null,
  arrival: null,
  duration: null,
  carrier: null,
  reference: null,
  check_in: null,
  check_out: null,
  nights: null,
  rating: null,
  amenities: [],
  included: [],
  public_price: null,
  deal_price: null,
  price_label: null,
  notes: null,
});

// Extract a YouTube video ID from any URL form
export const youtubeId = (url) => {
  if (!url) return null;
  const m = String(url).match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([\w-]{11})/);
  return m ? m[1] : null;
};

export const mapsEmbedUrl = (q) => {
  if (!q) return null;
  return `https://www.google.com/maps?q=${encodeURIComponent(q)}&output=embed`;
};

export const formatPrice = (n, cur = "EUR") =>
  n == null ? null : `${Number(n).toLocaleString("fr-FR", { maximumFractionDigits: 0 })} ${cur}`;
